const {
  DM_Handler
} = require("./handlers/DM");
const {
  ASC_Handler,
  AddASCClickableHandlers,
  AddASCNavHandlers,
  AddASCClickToCallHandlers
} = require("./handlers/ASC");
const {
  Incubeta_Handler,
  AddIncubetaNavHandlers,
  AddIncubetaClickableHandlers
} = require("./handlers/Incubeta");
const {
  Motorrad_Handler,
  SDBSession
} = require("./handlers/Motorrad");
const {
  GoogleTag_Handler
} = require("./handlers/GoogleTag");
const {
  Maserati_Handler,
  MaseratiSDBSession
} = require("./handlers/Maserati");

/**
 * Capture events and process them
 * @param {object} data - Event data to be processed.
 * @param {object} options - Custom configuration for data processing.
 * @returns {string} Success or failure message of data processing.
 */
function captureEvent(data, options) {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof window !== 'undefined') {
        // Check if data is empty
        if (data.length === 0) {
          reject('Cannot capture event, data object is empty.');
        }
        // Initialize response
        let response = [];
        // Check if options and handlers exist
        if (options && options.handlers) {
          // Get handlers from options
          const handlers = options.handlers || [];
          // Loop through handlers
          for (let i = 0; i < handlers.length; i++) {
            let handler = handlers[i];
            // Process data based on handler
            switch (handler) {
              case 'ASC':
                response.push(ASC_Handler(data, options));
                break;
              case 'Incubeta':
                response.push(Incubeta_Handler(data, options));
                break;
              case 'Motorrad':
                response.push(Motorrad_Handler(data, options));
                break;
              case 'Maserati':
                response.push(Maserati_Handler(data, options));
                break;
            }
          }
        }
        // Check if gtag exists and process data with gtag
        if (window.gtag) {
          response.push(GoogleTag_Handler(data, options));
        } else {
          response.push({
            status: 'error',
            message: 'GoogleTag Handler failed to capture event. Error: gtag is not defined',
            data: data
          });
        }
        // Process data with DM handler by default
        response.push(DM_Handler(data, options));
        // Resolve response
        resolve(response);
      } else {
        reject('Cannot capture event, Window is not defined.');
      }
    } catch (err) {
      reject(err);
    }
  });
}

/**
 * Store events in local storage for later processing.
 * @param {object} data - Event data to be processed.
 * @param {object} options - Custom configuration for data processing.
 * @returns {string} Success or failure message of data processing.
 */
function storeEvent(data, options) {
  return new Promise(async (resolve, reject) => {
    try {
      const captureEvents = JSON.parse(localStorage.getItem('captureEvents')) || [];
      captureEvents.push({
        data,
        options
      });
      localStorage.setItem('captureEvents', JSON.stringify(captureEvents));
      resolve('Event stored successfully');
    } catch (err) {
      reject(err);
    }
  });
}

/**
 * Process stored events in local storage.
 * @returns {string} Success or failure message of data processing.
 */
function processStoredEvents() {
  // Processes stored events
  return new Promise(async (resolve, reject) => {
    try {
      const captureEvents = JSON.parse(localStorage.getItem('captureEvents')) || [];
      if (captureEvents.length > 0) {
        captureEvents.forEach(event => {
          captureEvent(event.data, event.options).then(response => {
            console.log(response);
          }).catch(error => {
            console.log(error);
          });
        });
        localStorage.removeItem('captureEvents');
      }
      resolve('Stored events processed successfully');
    } catch (err) {
      reject(err);
    }
  });
}

/**
 * Expose captureEvent to window for client-side Javascript access.
 * @returns {void}
 */
function exposeCaptureEvent() {
  // Expose captureEvent function to global scope
  window.captureEvent = captureEvent;
}
module.exports = {
  captureEvent,
  storeEvent,
  processStoredEvents,
  exposeCaptureEvent,
  AddIncubetaNavHandlers,
  AddIncubetaClickableHandlers,
  AddASCNavHandlers,
  AddASCClickableHandlers,
  AddASCClickToCallHandlers,
  SDBSession,
  MaseratiSDBSession
};